var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.changePasswordPopup
        ? _c("cm-change-password-popup", {
            staticClass: "z-10080",
            attrs: { data: _vm.changePasswordPopupData },
            on: {
              close: function ($event) {
                _vm.changePasswordPopup = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("cm-switch-profile", { attrs: { closeButton: true } }),
      _vm._v(" "),
      _c("cm-user-reset-password", { attrs: { closeButton: true } }),
      _vm._v(" "),
      _vm.documentViewer
        ? _c("document-viewer", {
            attrs: { data: _vm.documentViewerData },
            on: {
              close: function ($event) {
                _vm.documentViewer = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.jsonDetails
        ? _c("cm-json-details", {
            attrs: { jsonDetailsData: _vm.jsonDetailsData },
            on: {
              close: function ($event) {
                _vm.jsonDetails = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }